import React, { useState, useEffect } from 'react';
import { Upload, Button, Card, Image, Space, Typography, message, Tooltip, Tag, Spin } from 'antd';
import { CameraOutlined, StarOutlined, StarFilled, DeleteOutlined } from '@ant-design/icons';
import api from '../services/api';

const { Text } = Typography;

function UploadFotos({ laudoId }) {
  const [fotos, setFotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imgUrls, setImgUrls] = useState({});

  useEffect(() => { if (laudoId) carregarFotos(); }, [laudoId]);

  const carregarFotos = async () => {
    try {
      const r = await api.get(`/laudos/${laudoId}`);
      const fotosData = r.data.fotos || [];
      setFotos(fotosData);
      // Carregar imagens via API autenticada
      fotosData.forEach(foto => carregarImagem(foto));
    } catch {}
  };

  const carregarImagem = async (foto) => {
    try {
      const r = await api.get(`/upload/laudos/${laudoId}/fotos/${foto.arquivo}`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      setImgUrls(prev => ({ ...prev, [foto.arquivo]: url }));
    } catch {}
  };

  const handleUpload = async (file) => {
    // Retorna false para evitar upload automatico do antd, mas processa o arquivo
    const formData = new FormData();
    formData.append('fotos', file);
    try {
      setLoading(true);
      const r = await api.post(`/upload/laudos/${laudoId}/fotos`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setFotos(r.data.fotos);
      // Carregar nova imagem
      r.data.fotos.forEach(foto => {
        if (!imgUrls[foto.arquivo]) carregarImagem(foto);
      });
      message.success('Foto adicionada!');
    } catch { message.error('Erro ao enviar foto'); }
    finally { setLoading(false); }
    return false;
  };

  const definirPrincipal = async (arquivo) => {
    try {
      const r = await api.put(`/upload/laudos/${laudoId}/fotos/${arquivo}/principal`);
      setFotos(r.data.fotos);
      message.success('Foto de capa definida!');
    } catch { message.error('Erro ao definir foto principal'); }
  };

  const excluirFoto = async (arquivo) => {
    try {
      const r = await api.delete(`/upload/laudos/${laudoId}/fotos/${arquivo}`);
      setFotos(r.data.fotos);
      setImgUrls(prev => { const n = {...prev}; delete n[arquivo]; return n; });
      message.success('Foto excluída!');
    } catch { message.error('Erro ao excluir foto'); }
  };

  if (!laudoId) return (
    <div style={{ padding: 16, background: '#fffbe6', borderRadius: 8, textAlign: 'center' }}>
      <Text type="warning">Salve o laudo primeiro para adicionar fotos.</Text>
    </div>
  );

  return (
    <div>
      <Upload accept="image/*" showUploadList={false} beforeUpload={handleUpload} multiple={true} disabled={loading}>
        <Button icon={<CameraOutlined />} loading={loading} type="primary" ghost>Adicionar Foto</Button>
      </Upload>
      <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>Clique em ⭐ para definir a foto de capa do relatório</Text>

      {fotos.length === 0 && !loading && (
        <div style={{ marginTop: 12, padding: 16, background: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}>
          <Text type="secondary">Nenhuma foto adicionada ainda.</Text>
        </div>
      )}

      <Spin spinning={loading}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 16 }}>
          {fotos.map((foto) => (
            <Card key={foto.arquivo} size="small"
              style={{ width: 160, border: foto.principal ? '2px solid #1a6ca8' : '1px solid #ddd' }}
              cover={
                imgUrls[foto.arquivo]
                  ? <img src={imgUrls[foto.arquivo]} alt={foto.nome} style={{ height: 120, objectFit: 'cover', width: '100%' }} />
                  : <div style={{ height: 120, background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Text type="secondary">Carregando...</Text></div>
              }
              actions={[
                <Tooltip title={foto.principal ? 'Foto de capa' : 'Definir como capa'}>
                  <Button type="text" icon={foto.principal ? <StarFilled style={{ color: '#faad14' }} /> : <StarOutlined />} onClick={() => definirPrincipal(foto.arquivo)} size="small" />
                </Tooltip>,
                <Tooltip title="Excluir foto">
                  <Button type="text" danger icon={<DeleteOutlined />} onClick={() => excluirFoto(foto.arquivo)} size="small" />
                </Tooltip>
              ]}
            >
              <Card.Meta description={foto.principal ? <Tag color="blue" style={{ fontSize: 10 }}>Capa do relatório</Tag> : <Text style={{ fontSize: 10 }} type="secondary">⭐ para usar como capa</Text>} />
            </Card>
          ))}
        </div>
      </Spin>
    </div>
  );
}

export default UploadFotos;
